window.okeReviewsWidgetOnInit = function () {
  // Setup Mutation Observer for individual reviews
  const reviewMain = document.querySelector(".js-okeReviews-reviews-main");
  if (reviewMain) {
    const observer = new MutationObserver(formatDateForElement);
    observer.observe(reviewMain, { childList: true });
    formatDateForElement();
  }
};

// Scroll to Okendo reviews when clicking PDP rating summary
document.addEventListener("click", (e) => {
  const trigger = e.target instanceof Element ? e.target.closest(".product-details .rating-wrapper") : null;
  if (!trigger) return;

  const widget = document.querySelector("[data-oke-reviews-widget]");
  const widgetContainer = widget?.closest(".shopify-section");
  if (!widgetContainer) return;

  e.preventDefault();
  widgetContainer?.scrollIntoView({ behavior: "smooth", block: "start" });
});

function setupIndividualReview(reviewElement) {
  formatDateForElement(reviewElement);
}

window.okeReviewsQandaOnInit = function () {
  const questionMain = document.querySelector(".js-okeReviews-questions-main");
  if (questionMain) {
    const callback = function (mutationList) {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach((n) => formatDateForElement(n));
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(questionMain, { childList: true });

    const questions = document.querySelectorAll(".okeReviews-question");
    questions.forEach((n) => formatDateForElement(n));
  }
};

// Change relative time format into format: MM/DD/YYYY
function formatDateForElement() {
  const reviewDates = document.querySelectorAll("[data-oke-reviews-date]");
  for (const reviewDate of reviewDates) {
    const dateIsoString = reviewDate.getAttribute("data-oke-reviews-date");
    const date = new Date(dateIsoString);
    const localeDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
    reviewDate.innerText = localeDate;
  }
}